import { TFunction } from 'i18next';
import { StyledDate, StyledSelectContainer, StyledSelectedRange } from './ResultsTracking.styles';
import { DateRangeDropdown, DateRangeOptionId, DateRangeSelection } from '@builder';
import { LAYOUT_THREE } from '@/common/constants';
import { getDateWithoutTZ, getSelectedDateRangeString } from '@/common/utils';
import { styled } from '@/stitches.config';
import TooltipByOrganization from '../ParticipantRecluitment/shared/TooltipByOrganization/TooltipByOrganization';
import { PartnerOrganization } from '@/modules/core/types/partnerType.type';

const RootContainer = styled('section', {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'baseline',
  margin: '$7 0',
  width: '100%',
});

const DateFilterContainer = styled('div', {
  display: 'flex',
});

const TooltipContainer = styled('div', {
  display: 'flex',
});

interface SubPageHeaderProps {
  t: TFunction;
  startDateGoal?: string;
  endDateGoal?: string;
  handleSelectDateRange: (selection: DateRangeSelection) => void;
  selectedDataLabel: string;
}

export const SubPageHeader = ({
  startDateGoal,
  endDateGoal,
  selectedDataLabel,
  handleSelectDateRange,
  t,
}: SubPageHeaderProps): JSX.Element => {
  return (
    <RootContainer>
      <DateFilterContainer>
        <StyledSelectedRange data-testid="selected-date-range">
          {t('selected_date_range.label')}
          <StyledDate> {selectedDataLabel} </StyledDate>
        </StyledSelectedRange>
        <StyledSelectContainer>
          <DateRangeDropdown
            value={{
              startDate: undefined,
              endDate: undefined,
              selectedDateRange: DateRangeOptionId.ALL_TIME,
            }}
            dateRangeErrorTitle={t('selected_date_range.error.title')}
            dateRangeErrorDescription={t('selected_date_range.error.description', {
              dateRange:
                startDateGoal &&
                endDateGoal &&
                getSelectedDateRangeString(
                  new Date(getDateWithoutTZ(startDateGoal)),
                  new Date(getDateWithoutTZ(endDateGoal)),
                ),
            })}
            maxDate={endDateGoal ? new Date(getDateWithoutTZ(endDateGoal)) : undefined}
            minDate={startDateGoal ? new Date(getDateWithoutTZ(startDateGoal)) : undefined}
            onSelect={handleSelectDateRange}
            layout={LAYOUT_THREE}
          />
        </StyledSelectContainer>
      </DateFilterContainer>
      <TooltipContainer>
        <TooltipByOrganization
          t={t}
          configuredPartners={[
            PartnerOrganization.RENOWN,
            PartnerOrganization.HELIX_RENOWN,
            PartnerOrganization.HEALTH_PARTNERS,
            PartnerOrganization.HELIX_HEALTH_PARTNERS,
            PartnerOrganization.MUSC,
            PartnerOrganization.HELIX_MUSC,
          ]}
          direction="column"
          translationsKey="delivery_and_results.cdc1_tier_results"
        />
      </TooltipContainer>
    </RootContainer>
  );
};
